import axios from "axios";
import {apiUrl} from "./setting";

export const getHeader = () => {
    let token = localStorage.getItem('token');
    let obj = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH',
        'Access-Control-Allow-Credentials': true,
        "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        'X-Requested-With': 'XMLHttpRequest',
        'crossdomain': true,
        'Content-Type': 'application/json;charset=utf-8',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Authorization': 'Bearer ' + (token || "")
    }
    return obj
}

export let customAxios = axios.create({
    baseURL: apiUrl,
    headers: getHeader(),
    timeout: 300000, // Timeout in milliseconds (e.g. 30 seconds)
});

export const getToken = () => {
    return {
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};




customAxios.interceptors.response.use(function (response) {
    if (response.status == 200) {
    }
    return response
}, function (error) {
    handleErr(error)
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
})

export const handleErr = (err) => {
    try {
        if (err.response.status === 401) {
            localStorage.clear()
            window.location.reload()
        }
    } catch (e) {
    }
}
